import { throttleStamp } from "./index";
export const mouseEvent = (option) => {
    if (!option.target) {
        return;
    }
    let callback = option.callback || function () { };
    let target = option.target;

    /*
     * 统一使用标准 wheel 事件，delta 语义固定为：
     *   delta > 0  =>  向下滚动
     *   delta < 0  =>  向上滚动
     *
     * 之前用旧版 mousewheel 事件，各浏览器取值符号并不一致：
     *   - mousewheel 的 wheelDelta：向上为正（Chrome/Edge/Safari）
     *   - DOMMouseScroll 的 detail ：向下为正（Firefox）
     * 两者混用会导致 Firefox 下滚动方向与其它浏览器相反。
     */
    const handleWheel = (e) => {
        let delta = e.deltaY;
        if (typeof delta !== "number" || delta === 0) {
            if (typeof e.wheelDelta === "number" && e.wheelDelta !== 0) {
                // wheelDelta 向上为正，取负后与 deltaY 保持一致
                delta = -e.wheelDelta;
            } else if (typeof e.detail === "number" && e.detail !== 0) {
                // detail 向下为正
                delta = e.detail;
            }
        }
        if (!delta) {
            return;
        }
        // 触控板横向滑动不触发翻页
        if (Math.abs(e.deltaX || 0) > Math.abs(delta)) {
            return;
        }
        const path = e.path || (e.composedPath && e.composedPath()) || [];
        for (let index = 0; index < path.length; index++) {
            const element = path[index];
            if (document.getElementsByClassName("ivu-select-dropdown").length > 0) {
                if (element.parentElement === document.getElementsByClassName("ivu-select-dropdown")[0]) {
                    return false;
                }
            }
            if (element.parentElement === target) {
                callback(e, delta);
                break;
            }
        }
    };

    document.addEventListener("wheel", throttleStamp(handleWheel, 1000), { passive: true });
};
